<div #stageOuterContainer class="presenter-view-root">
  <gb-presenter-canvas
    [responsive]="true"
    [draggable]="false"
    [inPreviewMode]="true"
    [backgroundColor]="backgroundColor$ | async"
    [backgroundImage]="backgroundImageUrl$ | async"
    [backgroundImageCover]="backgroundImageCover$ | async"
    [customCss]="customCss$ | async"
    (deselectWidget)="onGeneralClick()"
  ></gb-presenter-canvas>

  @if (!previewMode) {
    <div class="presenter-view-fullscreen-hotzone">
      <button
        type="button"
        class="presenter-view-fullscreen-button"
        (click)="toggleFullscreen(); $event.stopPropagation()"
      >
        @if (isFullscreen$ | async) {
          {{ 'PRESENTER.EXIT_FULLSCREEN' | translate }}
        } @else {
          {{ 'PRESENTER.GO_FULLSCREEN' | translate }}
        }
      </button>
    </div>
  }

  <div class="presenter-view-slide-nav-hotzone">
    <div class="presenter-view-slide-nav" (click)="$event.stopPropagation()">
      <button
        type="button"
        class="presenter-view-slide-nav-button"
        [disabled]="(canGoPreviousSlide$ | async) === false"
        (click)="selectPreviousSlide(); $event.stopPropagation()"
        aria-label="Previous slide"
      >
        <gb-icon icon="keyboard_arrow_left" [library]="IconLibrary.material"></gb-icon>
      </button>

      <div class="presenter-view-slide-nav-index">{{ currentSlideDisplayIndex$ | async }}</div>

      <button
        type="button"
        class="presenter-view-slide-nav-button"
        [disabled]="(canGoNextSlide$ | async) === false"
        (click)="selectNextSlide(); $event.stopPropagation()"
        aria-label="Next slide"
      >
        <gb-icon icon="keyboard_arrow_right" [library]="IconLibrary.material"></gb-icon>
      </button>
    </div>
  </div>
</div>
